import util from '../util/common';
import Cookies from 'js-cookie';
import invoking from '../util/invoking';

export const getIsMiniProgram = userAgent => {
    return userAgent.wx && util.checkMiniProgram();
};

function validParams(reject, payInfo, options) {
    const jumpModeValidList = [undefined, 0, 1];
    if (!(payInfo && payInfo.type && payInfo.param)) {
        reject({code: 500, msg: '缺少参数或者参数格式错误，第一个传入参数格式应为{type: "xx", param:"xx"}'});
        return false;
    } else if (options.isGoMiddlePage && !payInfo.order_sn) {
        reject({code: 500, msg: '第一个传入的参数data.order_sn应该有值'});
        return false;
    } else if (Object.prototype.toString.call(options) !== '[object Object]') {
        reject({code: 500, msg: '第二个传入参数类型应为对象'});
        return false;
    } else if (jumpModeValidList.indexOf(options.jumpMode) === -1) {
        reject({code: 500, msg: '第二个传入参数option.jumpMode应为0或1'});
        return false;
    } else {
        return true;
    }
}

function checkInWxMamayunyu(userAgent, name) {
    return getIsMiniProgram(userAgent) && name === 'mamayunyu';
}

// 补全支付参数选项
function fullPayOption(options = {}) {
    const result = Object.assign(
        {
            autoReturn: true,
            isGoMiddlePage: false,
            jumpMode: 0, // 0 表示 href 跳转， 1 replace 跳转
            isDebug: false
        },
        options
    );
    result.miniProgram = Object.assign(
        {
            name: '',
            successUrl: '',
            failUrl: '',
            destroy: 0
        },
        options.miniProgram || {}
    );
    return result;
}

function getType(userAgent, payInfo) {
    let resultType = 0;
    const {type} = payInfo;
    const map = {
        appwxmini: 4,
        appalipaymini: 5
    };
    const mapType = map[type];
    if (mapType) {
        resultType = mapType;
    } else if (userAgent.wx && type === 'array') {
        resultType = 2;
    } else if ((userAgent.pregnancyhelper || userAgent.mmq) && type === 'url') {
        resultType = 1;
    } else if (type === 'url') {
        resultType = 3;
    }
    return resultType;
}
/**
 *
 * @param {Function} resolve
 * @param {Function} reject
 * @param {Object} payInfo
 * @param {Object} options // options.payType 支付类型， options.isDebug: 是否调试模式
 */
function payWithType({resolve, reject, payInfo, options = {}, userAgent}) {
    const {payType, isDebug, miniProgram} = options;
    const payCallback = res => {
        if (res.code === '0') {
            resolve({code: 0, msg: 'app支付成功'});
        } else {
            reject({code: 500, msg: 'app支付错误'});
        }
    };
    const param = payInfo.param;
    switch (payType) {
        // APP支付（指代孕管内 支付宝app支付和微信app支付）
        case 1:
            window.Mama = window.Mama || {};
            window.Mama.wechatPay = payCallback;
            window.Mama.alipay = payCallback;
            location.href = param.replace(/return_url=.*?&/, '').replace(/&return_url=.*$/, '');
            break;
        // 微信公众号支付
        case 2:
            if (window.WeixinJSBridge) {
                window.WeixinJSBridge.invoke('getBrandWCPayRequest', param, function (res) {
                    if (res.err_msg === 'get_brand_wcpay_request:ok') {
                        resolve({code: 0, msg: res.err_msg});
                    } else {
                        reject({code: 500, msg: res.err_msg});
                    }
                });
            } else {
                reject({code: 500, msg: '缺少WeixinJSBridge'});
            }
            break;
        case 3:
            location.href = param;
            break;
        // 中行支付，调起孕育小程序支付
        case 4:
            if (checkInWxMamayunyu(userAgent, miniProgram.name)) {
                wx.miniProgram.navigateTo({
                    url: `/page/pay2${param.query}&success_url=${encodeURIComponent(
                        miniProgram.successUrl
                    )}&fail_url=${encodeURIComponent(miniProgram.failUrl)}&destroy=${miniProgram.destroy}`
                });
            } else {
                invoking({
                    action: 'launchWxMini',
                    data: {
                        miniId: param.mini_id,
                        miniPath: `${param.mini_path}${param.query}`,
                        miniProgramType: isDebug ? 2 : 0 // 0:正式，1:开发，2:体验版
                    },
                    option: {
                        success: function (res) {
                            // 可能会没有回调，比如用户直接没有点按钮回到app并且10.0.0.0以上才支持该回调
                            const {extMsg} = res;
                            if (!extMsg) {
                                return;
                            }
                            const payStatus = Number(extMsg.replace('pay_status=', ''));
                            if (payStatus === 1) {
                                resolve({code: 0, msg: '小程序支付成功'});
                            } else if (payStatus === -1) {
                                reject({code: 500, msg: '小程序支付失败'});
                            }
                        }
                    }
                });
            }
            break;
        case 5:
            location.href = param.url;
            break;
        default:
            reject({
                code: 500,
                msg: '只有在孕管app、轻聊app、微信、微信小程序、普通移动浏览器中能使用这个方法'
            });
    }
}

function jumpMiddlePage({payInfo, options, userAgent}) {
    const {isGoMiddlePage, payType, autoReturn, jumpMode} = options;
    if (isGoMiddlePage && userAgent.pregnancyhelper && (payType === 4 || payType === 5)) {
        setTimeout(() => {
            const jumpModeNum = Number(jumpMode);
            const url = `https://pay.xiaoshuxiong.com/paypage/paymentMiddle?order_sn=${
                payInfo.order_sn
            }&autoReturn=${Number(autoReturn)}&backReturn=${jumpModeNum}`;
            if (jumpModeNum === 0) {
                location.href = url;
            } else if (jumpModeNum === 1) {
                location.replace(url);
            }
        }, 2000);
    }
}

/**
 * @param {Array} paymentList 支付列表源数据
 * @param {Object} options options.isFilterBocPay 中行支付是否替换原来的支付
 * @returns {Array}
 */
export function filterPayList(paymentList, options = {}) {
    const {UA: userAgent} = this;
    if (!paymentList || !paymentList.length) {
        return [];
    }
    if (Object.prototype.toString.call(options) !== '[object Object]') {
        throw new Error('第二个传入参数类型应为对象');
    }
    const {wx, app, wap, web} = {
        wx: ['wxpayweb', 'chinabankwxappweb','icbcwxgzh'], // 微信
        app: ['wxpay', 'alipayapp', 'alipayappn'], // 轻聊或孕育app
        wap: ['wxpaywap', 'alipay', 'alipaywapn'], // wap
        web: ['alipayweb', 'alipaywebn'] // pc
    };
    const {isFilterBocPay, miniProgramName} = options;
    const InWxMamayunyu = checkInWxMamayunyu(userAgent, miniProgramName);
    const enableWXFilterBoc = isFilterBocPay && (userAgent.pregnancyhelper || InWxMamayunyu);
    const isMiniProgram = getIsMiniProgram(userAgent);
    const checkValid = item => {
        const includePaycode = arr => {
            return arr.indexOf(item.pay_code) !== -1;
        };
        const isPc = !userAgent.sys;
        const isWap = !isPc && !userAgent.wx && !userAgent.mmq && !userAgent.pregnancyhelper;
        const isWxWeb = userAgent.wx && !util.checkMiniProgram();
        if (
            (isMiniProgram && item.app_id === '3' && includePaycode(wx)) ||
            (isWxWeb && item.app_id === '0' && includePaycode(wx)) ||
            (userAgent.mmq && item.app_id === '1' && includePaycode(app)) ||
            ( item.pay_code === 'icbcappwxmini' && enableWXFilterBoc) ||
            (item.pay_code === 'icbcappalipaymini' && isFilterBocPay && userAgent.pregnancyhelper) ||
            (item.pay_code === 'chinabankwxapp' && enableWXFilterBoc) ||
            (item.pay_code === 'chinabankalipayapp'&& isFilterBocPay && userAgent.pregnancyhelper) ||
            (userAgent.pregnancyhelper && (item.app_id === '0' || item.app_id === '2') && includePaycode(app)) ||
            (isWap && includePaycode(wap)) ||
            (isPc && includePaycode(web))
        ) {
            return true;
        }
        return false;
    };
    const reg1 = /wx/;
    const reg2 = /alipay/;
    let weixinpay, alipay;
    const compareItem = (arr, current, item) => {
        const isReplace1 = current && arr.indexOf(item.pay_code) > arr.indexOf(current.pay_code);
        const isReplace2 =
            current && arr.indexOf(item.pay_code) === arr.indexOf(current.pay_code) && item.id > current.id;
        if (!current || isReplace1 || isReplace2) {
            return item;
        } else {
            return current;
        }
    };
    paymentList.forEach(item => {
        if (!checkValid(item)) {
            return false;
        }
        if (reg1.test(item.pay_code)) {
            const arr = ['wxpayweb', 'chinabankwxappweb', 'wxpay', 'chinabankwxapp', 'wxpaywap','icbcwxgzh','icbcappwxmini'];
            weixinpay = compareItem(arr, weixinpay, item);
        } else if (reg2.test(item.pay_code)) {
            const arr = [
                'alipayweb',
                'alipaywebn',
                'alipay',
                'alipaywapn',
                'alipayapp',
                'alipayappn',
                'chinabankalipayapp',
                'icbcappalipaymini'
            ];
            alipay = compareItem(arr, alipay, item);
        }
    });
    const payList = [];
    const checkPush = item => {
        if (item) {
            payList.push(item);
        }
    };
    checkPush(weixinpay);
    checkPush(alipay);
    return payList;
}

/**
 * @param {String or Object} payInfo 创建订单返回的对象{type:'xx', param:''}
 * @param {Object} options options.isDebug 是否开启调试模式 options.isGoMiddlePage 是否跳转中间页
 * @returns {Promise}
 */
function goToPay(payInfo, options = {}) {
    const {UA: userAgent} = this;
    return new Promise((resolve, reject) => {
        const validInfo = validParams(reject, payInfo, options);
        if (!validInfo) {
            return;
        }
        options = fullPayOption(options);
        const payType = getType(userAgent, payInfo);
        options.payType = payType;
        payWithType({resolve, reject, payInfo, options, userAgent});
        // 中行支付跳中间页等待结果
        jumpMiddlePage({payInfo, options, userAgent});
    });
}

// 获取微信公众号支付所需的openid
function getOpenId() {
    try {
        return JSON.parse(decodeURIComponent(Cookies.get('weixin_info')).replace('weixin_info=', ''))['openid'];
    } catch {
        return '';
    }
}

export default {
    getOpenId,
    filterPayList,
    goToPay
};
